import React from 'react';
import { useParams, Navigate } from 'react-router-dom';
import { blogPosts } from '../../data/blogData';
import Sidebar from './Sidebar';
import './BlogDetails.css';
import { Helmet } from 'react-helmet';


function BlogDetails() {
  const { slug } = useParams();
  const post = blogPosts.find((p) => p.slug === slug);

  if (!post) {
    return <Navigate to="/" replace />;
  }

  return (
<>

        <Helmet>
      <title>{post.meta_title}</title>
      <meta
        name="description"
        content={post.meta_description}
      />
      <link
        rel="canonical"
        href={`https://www.uniqueengineersltd.com/blog/${post.slug}`}
      />
    </Helmet>

    <main className="blog-detail-template">
      <div className="container blog-container">
        <div className="row g-5">
          <article className="col-lg-9">
            <img className="post-image" src={post.image} alt={post.title} />

            <div className="post-header">
              <div className="post-date">
                <span className="day">{post.day}</span>
                <span className="month">{post.month}</span>
              </div>

              <div className="post-heading">
                <h1 className="post-title">{post.title}</h1>
                <div className="post-meta">
                  <span>
                    <i className="bi bi-person"></i> By <a href="#">{post.author}</a>
                  </span>
                </div>
              </div>
            </div>

            {/* <div className="post-body">
              {post.content.map((paragraph, idx) => (
                <p key={idx}>{paragraph}</p>
              ))}
            </div>*/}

            <div
  className="post-body"
  dangerouslySetInnerHTML={{ __html: post.content }}
            />

          </article>

          <Sidebar />
        </div>
      </div>
    </main>
    </>
  );
}

export default BlogDetails;
